import Link from "next/link";
import { Card as BootstrapCard } from "react-bootstrap";
import moment from "moment";

import Image from "../Image";

function Card({ title, preview, image, url, date, j }) {
  //   let displayTop = post.image.height > 700 ? { top: "-25%" } : {};
  return (
    <BootstrapCard className="mb-md-3">
      <BootstrapCard.Img
        as={Image}
        url={url}
        src={image.url}
        width={image.width}
        height={image.height}
        variant="top"
        priority={j < 3}
      />
      <BootstrapCard.Body>
        <BootstrapCard.Title>
          <Link href={url} className="neutral-color">
            {title}
          </Link>
        </BootstrapCard.Title>
        <BootstrapCard.Text className="text-uppercase mb-2">
          <b>
            <small>
              {moment(date).format("MMMM D, YYYY")}
            </small>
          </b>
        </BootstrapCard.Text>
        <BootstrapCard.Text>{preview}</BootstrapCard.Text>
      </BootstrapCard.Body>
    </BootstrapCard>
  );
}

export default Card;
